export const routes = {
  dashboard: '/',
  feeds: '/feeds',
  feed: (id: string) => `/feeds/${encodeURIComponent(id)}`,
  services: '/services',
  serviceUpdate: (id: string) => `/services/${encodeURIComponent(id)}/update`,
  serviceMove: (id: string) => `/services/${encodeURIComponent(id)}/move`,
  listingVideos: '/listing-videos',
  customers: '/customers',
  customerNew: '/customers/new',
  customerEnableSocial: (id: string) => `/customers/${encodeURIComponent(id)}/enable-social`,
  customerDisconnectSocial: (id: string) =>
    `/customers/${encodeURIComponent(id)}/disconnect-social`,
  mlsAgreements: '/mls-agreements',
  mlsAgreementsMlsNew: '/mls-agreements/mls/new',
  mlsAgreementsMls: (id: string) => `/mls-agreements/mls/${encodeURIComponent(id)}`,
  mlsAgreementsCustomerNew: '/mls-agreements/customers/new',
  mlsAgreementsCustomer: (id: string) => `/mls-agreements/customers/${encodeURIComponent(id)}`,
  mlsAgreementsMembershipNew: '/mls-agreements/memberships/new',
  mlsAgreementsMembership: (id: string) => `/mls-agreements/memberships/${encodeURIComponent(id)}`,
  utilities: '/utilities',
  featureFlags: '/feature-flags',
  featureFlagsSection: (section: string) => `/feature-flags/${section}`,
  featureFlagsRecordNew: (section: string) => `/feature-flags/${section}/new`,
  featureFlagsRecord: (section: string, id: string) =>
    `/feature-flags/${section}/${encodeURIComponent(id)}`,
  featureFlagsAdmin: (area: string) => `/feature-flags/admin/${area}`,
  featureFlagsAdminRecordNew: (area: string) => `/feature-flags/admin/${area}/new`,
  featureFlagsAdminRecord: (area: string, id: string) =>
    `/feature-flags/admin/${area}/${encodeURIComponent(id)}`,
  ai: '/ai',
  aiAnalytics: '/ai/analytics',
  aiPlacements: '/ai/placements',
  aiPlacementNew: '/ai/placements/new',
  aiPlacement: (key: string) => `/ai/placements/${encodeURIComponent(key)}`,
  aiPersonas: '/ai/personas',
  aiPersonaNew: '/ai/personas/new',
  aiPersona: (id: string) => `/ai/personas/${id}`,
  aiDigitalAssistants: '/ai/digital-assistants',
  aiDigitalAssistantNew: '/ai/digital-assistants/new',
  aiDigitalAssistant: (id: string) => `/ai/digital-assistants/${id}`,
  /** The new-assistant page prefilled from an existing one. */
  aiDigitalAssistantDuplicate: (id: string) =>
    `/ai/digital-assistants/new?duplicate=${encodeURIComponent(id)}`,
  aiSettings: (section: string) => `/ai/settings/${section}`,
  uiKit: '/ui-kit', // dev builds only (app/App.tsx)
} as const;
